export enum EnsightenEventType {
  PAGE_START = 'virtual_page_view_start',
  PAGE_COMPLETE = 'virtual_page_view',
  OTHER = 'virtual_page_other'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/ensighten/ensighten-event-type.model.ts